export default "__VITE_ASSET__Dh1aL$Dz__"